export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      gallery: 'Galería',
      book: 'Libro',
      about: 'Sobre Mí',
      contact: 'Contacto',
      admin: 'Admin'
    },
    footer: {
      privacy: 'Política de Privacidad',
      legal: 'Aviso Legal',
      copyright: '© 2026 Gisselle Mendez'
    },
    hero: {
      title: 'Gisselle Mendez',
      subtitle: 'Explorando la luz y la textura a través de acrilicos abstractos.',
      cta: 'Ver Colección'
    },
    book: {
      heroTitle: 'OLIVIA GREY',
      heroSubtitle: 'Thriller Psicológico',
      buyAmazon: 'COMPRAR EN AMAZON',
      synopsisTitle: 'Sinopsis',
      synopsisText: 'En las profundidades de una mente fragmentada, Olivia Grey busca la verdad entre sombras y espejos. Un thriller que desafía la percepción y explora los límites de la identidad en una Barcelona envuelta en misterio.',
      aboutTitle: 'Sobre la Obra',
      description: 'Esta obra literaria nace de la misma curiosidad que guía mis pinceles: el deseo de desentrañar lo que se oculta tras la superficie. Una narrativa visual y cruda que transporta al lector a un laberinto emocional.',
      stats: {
        genre: 'Género',
        genreValue: 'Thriller Psicológico',
        year: 'Año de Debut',
        yearValue: '2025',
        inspiration: 'Inspiración',
        inspirationValue: 'Misterios Históricos',
        dedicated: 'Dedicado a',
        dedicatedValue: 'Kattie'
      }
    },
    gallery: {
      title: 'Obras Originales',
      filterAll: 'Todas',
      filterAvailable: 'Disponibles',
      filterSold: 'Vendidas',
      noResults: 'No se encontraron obras.'
    },
    artwork: {
      size: 'Tamaño',
      medium: 'Técnica',
      addCart: 'Añadir al Carrito',
      soldOut: 'Vendido',
      price: 'Precio'
    },
    about: {
      title: 'La Artista',
      bio1: 'Gisselle Mendez es una artista contemporánea radicada en Barcelona, especializada en acrylicos abstractos que exploran la relación entre la naturaleza, la memoria y la emoción.',
      bio2: 'Con formación en Bellas Artes, su obra se caracteriza por pinceladas expresivas y una paleta de tonos terrosos que invitan a la contemplación íntima.'
    },
    contact: {
      title: 'Contacto & Encargos',
      name: 'Nombre',
      email: 'Correo Electrónico',
      message: 'Mensaje',
      send: 'Enviar Mensaje',
      success: 'Mensaje enviado con éxito. Te responderemos pronto.'
    },
    admin: {
      title: 'Panel de Control',
      login: 'Iniciar Sesión',
      password: 'Contraseña (usa "admin")',
      addArtwork: 'Añadir Obra',
      save: 'Guardar',
      logout: 'Cerrar Sesión'
    }
  },
  en: {
    nav: {
      home: 'Home',
      gallery: 'Gallery',
      book: 'Book',
      about: 'About',
      contact: 'Contact',
      admin: 'Admin'
    },
    footer: {
      privacy: 'Privacy Policy',
      legal: 'Legal Notice',
      copyright: '© 2026 Gisselle Mendez'
    },
    hero: {
      title: 'Gisselle Mendez',
      subtitle: 'Exploring light and texture through contemporary acrylics.',
      cta: 'View Collection'
    },
    book: {
      heroTitle: 'OLIVIA GREY',
      heroSubtitle: 'Psychological Thriller',
      buyAmazon: 'BUY ON AMAZON',
      synopsisTitle: 'Synopsis',
      synopsisText: 'In the depths of a fragmented mind, Olivia Grey seeks the truth among shadows and mirrors. A thriller that challenges perception and explores the limits of identity in a Barcelona shrouded in mystery.',
      aboutTitle: 'About the Work',
      description: 'This literary work is born from the same curiosity that guides my brushes: the desire to unravel what is hidden beneath the surface. A visual and raw narrative that transports the reader to an emotional labyrinth.',
      stats: {
        genre: 'Genre',
        genreValue: 'Psychological Thriller',
        year: 'Debut Year',
        yearValue: '2025',
        inspiration: 'Inspiration',
        inspirationValue: 'Historic Mystery',
        dedicated: 'Dedicated to',
        dedicatedValue: 'Kattie'
      }
    },
    gallery: {
      title: 'Original Artworks',
      filterAll: 'All',
      filterAvailable: 'Available',
      filterSold: 'Sold',
      noResults: 'No artworks found.'
    },
    artwork: {
      size: 'Size',
      medium: 'Medium',
      addCart: 'Add to Cart',
      soldOut: 'Sold',
      price: 'Price'
    },
    about: {
      title: 'The Artist',
      bio1: 'Gisselle Mendez is a contemporary artist based in Barcelona, specializing in acryls that explore the relationship between nature, memory, and emotion.',
      bio2: 'With a background in Fine Arts, her work is characterized by expressive brushstrokes and an earthy palette that invites intimate contemplation.'
    },
    contact: {
      title: 'Contact & Commissions',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      send: 'Send Message',
      success: 'Message sent successfully. We will reply soon.'
    },
    admin: {
      title: 'Dashboard',
      login: 'Login',
      password: 'Password (use "admin")',
      addArtwork: 'Add Artwork',
      save: 'Save',
      logout: 'Logout'
    }
  }
};